<template>
  <div>
    <b-form-select v-model="selected" :options="options"></b-form-select>
  </div>
</template>

<script>

export default {
  name: "customer-role-select",
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: undefined
    },
  },
  data() {
    return {
      selected: this.value || null,
      options: [
        { value: null, text: this.placeholder || this.$t('Please select {something}', { something: this.$t('tickets.customer_type') })},
        { value: 'brs', text: this.$t('customers.types.brs') },
        { value: 'lcs', text: this.$t('customers.types.lcs') },
        { value: 'farmer', text: this.$t('customers.types.farmer') },
        { value: 'processing', text: this.$t('customers.types.processing') },
      ]
    }
  },
  watch: {
    selected(val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', val);
      }
    },
    value(val){
      this.selected = val !== this.selected ? val ?? null : this.selected;
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
